import ChevronRight from "@untitled-ui/icons-react/build/esm/ChevronRight";
import {
  Card,
  Col,
  Collapse,
  Divider,
  Dropdown,
  Row,
  Spin,
  Statistic,
  Tag,
  Typography,
} from "antd";
import {
  SafetyOutlined,
  EditOutlined,
  SettingOutlined,
  DislikeOutlined,
} from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import cnt from "../../../services/definedConstant";
import "../../../assets/styles/Bond.css";
import MainLayout from "../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../components/layouts/enhancement/TopContent";
import bondsList from "../../../config/data/bondsList.json";
import { apiConfig, labelConfig, staticConfig } from "../treasury.config";
// import { handleFlgStatus } from "../../../components/facilities/AccountFacility";
import {
  AccountFacility,
  handleFlgStatus,
} from "../../../components/facilities/TreasuryFacility";
import ChevronDown from "@untitled-ui/icons-react/build/esm/ChevronDown";
import { BOM } from "../../../services/definedMethod";
import { handleBondActionButtons } from "../../../components/facilities/TreasuryFacility";

const { Panel } = Collapse;
const { Text, Title } = Typography;

const ViewBond = (props) => {
  const { userData } = props;
  const { session } = userData;
  const { state: selectedBondKey } = useLocation();
  const navigate = useNavigate();

  const [bondDetails, setBondDetails] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [menuProps, setMenuProps] = useState({ items: [] });

  const formatFullDate = (date) => {
    if (!date) return "-";
    try {
      return new Date(date).toLocaleDateString("en-US", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    } catch {
      return "-";
    }
  };

  const getBondById = (params) => {
    const url = `${apiConfig.GetBondProduct}/${params}`;

    let body = {
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        setBondDetails(objDetail);

        setMenuProps({
          items: handleBondActionButtons(objDetail),
          onClick: (e) => {
            console.log(e);

            const item = handleBondActionButtons(objDetail).find(
              (element) => element.key === e.key
            );
            if (item) {
              switch (item?.label.toLowerCase()) {
                case "approve":
                  return activateBond();
                case "disable":
                  return disableBond();
                case "close":
                  return closeBond();

                default:
                  //ROUTE REDIRECTING ACTIONS
                  return navigate(item.route, {
                    state: {
                      // ...state,
                      accountNo: objDetail.accountNo,
                      actionLabel: item.label,
                      // branchId: temp.officeId,
                    },
                  });
              }
            }
          },
        });
        setIsLoading(false);
      }
    });
  };

  useEffect(() => {
    getBondById(selectedBondKey);
  }, []);

  const transformedData = [
    {
      section: "Product Information",
      items: [
        {
          name: "Product Code",
          value: bondDetails?.productCode ?? "-",
          isTag: true,
        },
        {
          name: "Product Name",
          value: bondDetails?.productName ?? "-",
          isTag: true,
        },
        {
          name: "Product Category",
          value: bondDetails?.bondProductCategory ?? "-",
          isTag: true,
        },
        {
          name: "Currency",
          value: bondDetails?.currencyCode ?? "-",
          isTag: true,
        },
        {
          name: "Issue Type",
          value: bondDetails?.bondIssueType?.text || "-",
          isTag: true,
        },
        {
          name: "Bond Type",
          value: bondDetails?.bondType?.text ?? "-",
          isTag: true,
        },
        {
          name: "Custodian",
          value: bondDetails?.custodian?.name ?? "-",
          isTag: true,
        },
        {
          name: "Accounting Classification",
          value: bondDetails?.accountingClassification?.name ?? "-",
          isTag: true,
        },
        {
          name: "Start Date",
          value: formatFullDate(bondDetails?.startDate) ?? "-",
        },
        {
          name: "End Date",
          value: formatFullDate(bondDetails?.endDate) ?? "-",
        },
      ],
    },
    {
      section: "Issuer Details",
      items: [
        {
          name: "Issuer Name",
          value: bondDetails?.bondIssuerName ?? "-",
          isTag: true,
        },
        {
          name: "Issuer Type",
          value: bondDetails?.issuerType?.name ?? "-",
          isTag: true,
        },
        {
          name: "Credit Rating (Fitch)",
          value: bondDetails?.creditRating ?? "-",
          isTag: true,
        },
        {
          name: "Country of Issue",
          value: bondDetails?.country?.name ?? "-",
          isTag: true,
        },
      ],
    },
    {
      section: "Bond Features",
      items: [
        {
          name: "Par Value/Cost Per Unit",
          value: bondDetails?.faceValue?.toLocaleString() ?? "-",
        },
        {
          name: "Issue Price",
          value: bondDetails?.bondIssuePrice?.text ?? "-",
          isTag: true,
        },
        {
          name: "Coupon Rate Option",
          value: bondDetails?.bondCouponRate?.text ?? "-",
          isTag: true,
        },
        {
          name: "Coupon Frequency",
          value: bondDetails?.bondCouponFrequency?.text ?? "-",
          isTag: true,
        },
        {
          name: "Maturity Date",
          value: formatFullDate(bondDetails?.maturityDate) ?? "-",
          isTag: true,
        },
        {
          name: "Tenor",
          value: bondDetails?.bondTenor?.toLocaleString() ?? "-",
        },
        {
          name: "Callable",
          value: bondDetails?.callable ? "Yes" : "No",
          isTag: true,
        },
        {
          name: "Putable",
          value: bondDetails?.puttable ? "Yes" : "No",
          isTag: true,
        },
        {
          name: "Convertible",
          value: bondDetails?.convertibleToEquity ? "Yes" : "No",
          isTag: true,
        },
        {
          isInlineGroup: true,
          group: [
            {
              name: "Repayment Type",
              isTagGroup: true,
              fields: [
                {
                  value: bondDetails?.allowRepaymentType ? "Yes" : "No",
                  isTag: true,
                },
                {
                  value: bondDetails?.bondAmortization?.text || "-",
                  isTag: true,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      section: "Interest Settings",
      items: [
        {
          name: "Interest Calculation Basis",
          value: bondDetails?.interestCalculationBasis?.text ?? "-",
          isTag: true,
        },
        {
          name: "Interest Start Date",
          value: bondDetails?.interestStartDate?.text ?? "-",
          isTag: true,
        },
        {
          name: "First Coupon Date",
          value: bondDetails?.firstCouponDate?.text ?? "-",
          isTag: true,
        },
        {
          name: "Interest Payment Mode",
          value: bondDetails?.bondInterestPaymentMode?.text ?? "-",
          isTag: true,
        },
      ],
    },
    {
      section: "Tax & Charges",
      items: [
        {
          isInlineGroup: true,
          group: [
            {
              name: "Tax Group",
              isTagGroup: true,
              fields: [
                {
                  value: bondDetails?.allowTax ? "Yes" : "No",
                  isTag: true,
                },
                {
                  value: bondDetails?.taxGroup?.name ?? "-",
                  isTag: true,
                },
              ],
            },
          ],
        },
        {
          isInlineGroup: true,
          group: [
            {
              name: "Processing Charges",
              isTagGroup: true,
              fields: [
                {
                  value: bondDetails?.setupCharges ? "Yes" : "No",
                  isTag: true,
                },
                {
                  value: bondDetails?.setupCharge?.name || "-",
                  isTag: true,
                },
              ],
            },
          ],
        },
        {
          isInlineGroup: true,
          group: [
            {
              name: "Redemption Charges",
              isTagGroup: true,
              fields: [
                {
                  value: bondDetails?.redemptionCharges ? "Yes" : "No",
                  isTag: true,
                },
                {
                  value: bondDetails?.redemptionCharge?.name || "-",
                  isTag: true,
                },
              ],
            },
          ],
        },
        {
          isInlineGroup: true,
          group: [
            {
              name: "Stamp Duty Charges",
              isTagGroup: true,
              fields: [
                {
                  value: bondDetails?.transferCharges ? "Yes" : "No",
                  isTag: true,
                },
                {
                  value: bondDetails?.transferCharge?.name || "-",
                  isTag: true,
                },
              ],
            },
          ],
        },
        {
          isInlineGroup: true,
          group: [
            {
              name: "Brokerage/Agent Commission",
              isTagGroup: true,
              fields: [
                {
                  value: bondDetails?.allowBrokerage ? "Yes" : "No",
                  isTag: true,
                },
                {
                  value: bondDetails?.commission?.name ?? "-",
                  isTag: true,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      section: "Accounting",
      items: [
        {
          isInlineGroup: true,
          group: [
            {
              name: "Investment - Deal Booking",
              isTagGroup: true,
              fields: [
                {
                  value: bondDetails?.investmentGL?.debitAccount?.name ?? "-",
                  isTag: true,
                },
                {
                  value: bondDetails?.investmentGL?.creditAccount?.name ?? "-",
                  isTag: true,
                },
              ],
            },
          ],
        },
        {
          isInlineGroup: true,
          group: [
            {
              name: "Interest Accrual Posting",
              isTagGroup: true,
              fields: [
                {
                  value:
                    bondDetails?.accruedInterestGL?.debitAccount?.name ?? "-",
                  isTag: true,
                },
                {
                  value:
                    bondDetails?.accruedInterestGL?.creditAccount?.name ?? "-",
                  isTag: true,
                },
              ],
            },
          ],
        },
        {
          isInlineGroup: true,
          group: [
            {
              name: "Investment - Redemption (Customer Payable)",
              isTagGroup: true,
              fields: [
                {
                  value: bondDetails?.settlementGL?.debitAccount?.name ?? "-",
                  isTag: true,
                },
                {
                  value: bondDetails?.settlementGL?.creditAccount?.name ?? "-",
                  isTag: true,
                },
              ],
            },
          ],
        },
        {
          isInlineGroup: true,
          group: [
            {
              name: "Income Interest Posting",
              isTagGroup: true,
              fields: [
                {
                  value:
                    bondDetails?.interestIncomeGL?.debitAccount?.name ?? "-",
                  isTag: true,
                },
                {
                  value:
                    bondDetails?.interestIncomeGL?.creditAccount?.name ?? "-",
                  isTag: true,
                },
              ],
            },
          ],
        },
        {
          isInlineGroup: true,
          group: [
            {
              name: "Income Fees Posting",
              isTagGroup: true,
              fields: [
                {
                  value: bondDetails?.feeGL?.debitAccount?.name ?? "-",
                  isTag: true,
                },
                {
                  value: bondDetails?.feeGL?.creditAccount?.name ?? "-",
                  isTag: true,
                },
              ],
            },
          ],
        },
        {
          isInlineGroup: true,
          group: [
            {
              name: "Income Penalty Posting",
              isTagGroup: true,
              fields: [
                {
                  value: bondDetails?.penaltyGL?.debitAccount?.name ?? "-",
                  isTag: true,
                },
                {
                  value: bondDetails?.penaltyGL?.creditAccount?.name ?? "-",
                  isTag: true,
                },
              ],
            },
          ],
        },
      ],
    },
  ];

  const dummyMenuItems = {
    items: [
      {
        label: "Modify Application",
        key: "1",
        route: "/savings-account-action",
        disabled: true,
        icon: <EditOutlined />,
      },
      {
        label: "Approve",
        key: "2",
        route: "/savings-account-action",
        disabled: true,
        icon: <SafetyOutlined />,
      },
      {
        label: "Reject",
        key: "3",
        route: "/savings-account-action",
        disabled: true,
        icon: <DislikeOutlined />,
      },
    ],
  };

  // Custom expand icon
  const expandIcon = ({ isActive }) => {
    return (
      <ChevronRight
        style={{
          fontSize: "8px",
          color: "#344054",
          display: "flex",
          alignItems: "center",
          transform: isActive ? "rotate(90deg)" : "rotate(0deg)",
          transition: "transform 0.2s ease",
        }}
      />
    );
  };

  const renderTag = (value) => {
    if (value === true) {
      return (
        <Tag
          style={{
            backgroundColor: "#ECFDF3",
            border: "1px solid #ABEFC6",
            borderRadius: "16px",
            padding: "2px 12px",
          }}
        >
          <Text
            style={{
              color: "#067647",
              fontWeight: 600,
            }}
          >
            Yes
          </Text>
        </Tag>
      );
    }

    if (value === false) {
      return (
        <Tag
          style={{
            backgroundColor: "#F9FAFB",
            border: "1px solid #EAECF0",
            borderRadius: "16px",
            padding: "2px 12px",
            textTransform: "capitalize",
          }}
        >
          <Text
            style={{
              color: "#344054",
              fontWeight: 600,
            }}
          >
            No
          </Text>
        </Tag>
      );
    }

    if (
      value === "-" ||
      value === null ||
      value === undefined ||
      value === ""
    ) {
      return (
        <Text style={{ fontWeight: 500, color: "#6b7280" }}>
          {value || "-"}
        </Text>
      );
    }

    // Default tag for select fields
    return (
      <Tag
        style={{
          backgroundColor: "#FDF4FF",
          border: "1px solid #F6D0FE",
          borderRadius: "16px",
          padding: "2px 12px",
        }}
      >
        <Text
          style={{
            textTransform: "capitalize",
            color: "#9F1AB1",
            fontWeight: 600,
          }}
        >
          {value}
        </Text>
      </Tag>
    );
  };

  const renderRow = (item, index, section) => {
    const isLastItem =
      index === (transformedData[section]?.items?.length || 0) - 1;

    const getDisplayValue = (val) => {
      if (val == null || val === "") return "-";
      if (typeof val === "object")
        return val.text || val.value || JSON.stringify(val);
      return val.toString();
    };

    if (item.isInlineGroup && Array.isArray(item.group)) {
      return item.group.map((fieldGroup, groupIndex) => (
        <div
          key={`inline-group-${fieldGroup.name}-${index}-${groupIndex}`}
          style={{
            display: "flex",
            borderBottom: isLastItem ? "none" : "1px solid #f0f0f0",
          }}
        >
          <div
            style={{
              padding: "16px 24px",
              width: "50%",
              backgroundColor: "#f9f9f9",
              fontWeight: "500",
              borderRight: "1px solid #f0f0f0",
            }}
          >
            {fieldGroup.name}
          </div>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "8px",
              padding: "16px 24px",
              width: "50%",
              backgroundColor: "#fff",
            }}
          >
            {fieldGroup.fields.map((subField) => (
              <div
                key={subField.name}
                style={{
                  display: "flex",
                  alignItems: "center",
                  fontWeight: 500,
                }}
              >
                {subField.isTag ? (
                  renderTag(getDisplayValue(subField.value))
                ) : (
                  <span>{getDisplayValue(subField.value)}</span>
                )}
              </div>
            ))}
          </div>
        </div>
      ));
    }

    return (
      <div
        key={item.key || item.name}
        style={{
          display: "flex",
          borderBottom: isLastItem ? "none" : "1px solid #f0f0f0",
        }}
      >
        <div
          style={{
            padding: "16px 24px",
            width: "50%",
            backgroundColor: "#f9f9f9",
            fontWeight: "500",
            borderRight: "1px solid #f0f0f0",
          }}
        >
          {item.name}
        </div>
        <div
          style={{
            padding: "16px 24px",
            width: "50%",
            backgroundColor: "#fff",
          }}
        >
          {item.isTag ? (
            renderTag(getDisplayValue(item.value))
          ) : (
            <Text style={{ textTransform: "capitalize", fontWeight: 600 }}>
              {getDisplayValue(item.value)}
            </Text>
          )}
        </div>
      </div>
    );
  };

  function activateBond() {
    setIsLoading(true);
    const params = {
      command: "activate",
    };

    const url = `${apiConfig.InterBankPlacement}/${selectedBondKey}/modify-status?`;

    const body = {
      method: "POST",
      session,
      params,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, "Product Activated succesfully");
        //STOP LOAD

        getBondById(selectedBondKey);
        setIsLoading(false);
      }
    });
  }
  function disableBond() {
    setIsLoading(true);
    const params = {
      command: "disable",
    };
    const url = `${apiConfig.InterBankPlacement}/${selectedBondKey}/modify-status?`;

    const body = {
      method: "POST",
      session,
      params,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, "Product Disabled succesfully");
        //STOP LOAD
        getBondById(selectedBondKey);

        setIsLoading(false);
      }
    });
  }
  function closeBond() {
    setIsLoading(true);
    const params = {
      command: "close",
    };
    const url = `${apiConfig.InterBankPlacement}/${selectedBondKey}/modify-status?`;

    const body = {
      method: "POST",
      session,
      params,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, "Product Closed succesfully");
        //STOP LOAD
        getBondById(selectedBondKey);

        setIsLoading(false);
      }
    });
  }

  return (
    <MainLayout pageItems={staticConfig.viewBondItems}>
      <TopContent
        pageTitle={labelConfig.bond}
        createPageTitle={labelConfig.viewBond}
      />
      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
            marginTop: 20,
          }}
        >
          <div layout="vertical" style={{ paddingTop: 20, marginBottom: 50 }}>
            <Row>
              <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                {labelConfig.generalInfo}
              </Title>
            </Row>
            <Divider style={{ marginTop: 10 }} />
            <Row>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Dropdown.Button
                  menu={menuProps}
                  icon={<SettingOutlined />}
                  placement="topLeft"
                >
                  Actions
                </Dropdown.Button>
              </Col>
            </Row>

            <AccountFacility
              status={bondDetails?.status?.text}
              name={bondDetails?.productName}
              id={bondDetails?.productCode}
              isProduct={true}
            />

            <Row
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 20,
              }}
            >
              {transformedData.map((section, index) => (
                <Col>
                  <Collapse
                    className="custom-collapse"
                    // expandIconPosition="start"
                    expandIcon={<ChevronDown color="red" />}
                    style={{
                      backgroundColor: "transparent",
                      padding: 0,
                    }}
                  >
                    <Panel
                      key={index + 1}
                      header={
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: 500,
                          }}
                        >
                          {section.section}
                        </span>
                      }
                      style={{
                        borderRadius: "8px",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        style={{
                          border: "1px solid #f0f0f0",
                          borderRadius: "8px",
                          overflow: "hidden",
                        }}
                      >
                        {section.items.map((item, itemIndex) =>
                          renderRow(item, itemIndex, index)
                        )}
                      </div>
                    </Panel>
                  </Collapse>
                </Col>
              ))}
            </Row>
          </div>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ViewBond);
